module.exports = __webpack_public_path__ + "img/up-arrow.565320e1.svg";